<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">非日常上报&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>非日常上报</div>
        </div>
      </div>
    </div>
    <!-- 北京市中关村中学知春分校 -->
    <div v-if="showChildFlag > 0" style="margin: 10 px;display: flex;justify-content: space-between; align-items: center;padding: 10px;background: #fff;">
      <span style="font-weight: bold;">{{ showChildText }}</span>
      <el-button size="small" type="info" @click="back">返回</el-button>
    </div>
    <div class="section" v-if="showChildFlag == 0">
      <div class="left">
        <div class="search-box">
          <el-input
            style="margin-right: 12px"
            placeholder="请输入任务名称"
            prefix-icon="el-icon-search"
            v-model="sxlx"
            clearable
          >
          </el-input>
          <el-select
            filterable
            placeholder="请选择部门"
            clearable
            v-model="deptName"
          >
            <el-option
              v-for="(item, index) in deptNameALL"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="type-list">
          <div
            class="type-list-item"
            :class="{ active: ghEventTypeId == item.id }"
            v-for="(item, index) in typeList"
            :key="index"
            @click="typeChange(item)"
          >
            <div class="item-top">
              <div class="name">{{ item.sxlx }}</div>
            </div>
            <div class="item-bottom">
              <div style="color: #909399">{{ item.tjDeptName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <div class="title">事项列表</div> -->
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.sxmc"
                    clearable
                    placeholder="请输入事项名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <common-table
            :select="false"
            :maxHeight="460"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :isShowPagination="false"
          >
            <template v-slot:ywcCount="{ scope }">
              <span>{{ scope.row.ywcCount }} / {{ scope.row.totalCount }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="openIssuesDialogFun(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >任务列表</el-button
              >
              <el-button
                @click="exportData(scope.row)"
                style="color: #eb3538; font-size: 16px"
                type="text"
                >导出批次</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <list :curTypeItem="issuesCurItem" v-if="showChildFlag == 1" @showChild="showChild"></list>
    <detail :detailId="detailId" v-if="showChildFlag == 2"></detail>
  </div>
</template>
<script>
import {
  selMyDoList,
  batchGroupSomeList,
  userLocationLineExp,
  extendTaskPageExp
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import list from './list.vue';
import detail from './detail.vue';
export default {
  components: {
    commonTable,
    list,
    detail
  },
  data() {
    return {
      showChildFlag: 0,
      showChildText: '食品安全问题预警任务列表',
      curTypeItem: {},
      sxlx: "",
      deptName: "",
      form: {
        sxmc: "",
        timeStart: "",
        timeEnd: ""
      },
      date: [],
      dialogVisible: false,
      ruleDialogVisible: false,
      detailId: null,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "eventName",
            label: "事项名称"
          },
          {
            prop: 'batchName',
            label: '批次名称'
          },
          {
            prop: 'eventTypeName',
            label: '事项类型名称'
          },
          // {
          //   prop: "username",
          //   label: "创建人"
          // },
          {
            prop: "time",
            label: "创建时间"
          },
          {
            slot: "ywcCount",
            label: "任务进度"
          },
          {
            slot: "operation",
            label: "操作",
            width: '300px'
          }
        ]
      },
      curItem: {},
      ruleCurItem: {},
      issuesCurItem: {},
      typeList: [],
      ghEventTypeId: null,
      exportLoading: false,
      typeListALL: [],
      deptNameALL: [],
    };
  },
  mounted() {
    this.selListFun();
  },
  methods: {
    showChild (e) {
      this.detailId = e.id;
      this.showChildFlag = 2;
      this.showChildText = e.eventTypeName;
    },
    back () {
      if (this.showChildFlag == 2) {
        this.showChildFlag = 1;
        this.showChildText = this.issuesCurItem.eventName;
        return false;
      }
      if (this.showChildFlag == 1) {
        this.showChildFlag = 0;
        this.showChildText = '';
        return false;
      }
    },
    typeChange(item) {
      this.ghEventTypeId = item.id;
      this.curTypeItem = item;
      this.eventPageFun();
    },
    openIssuesDialogFun(item) {
      this.issuesCurItem = {
        ...this.curTypeItem,
        ...item
      };
      if (!item) {
        this.issuesCurItem.id = "";
      }
      this.showChildFlag = 1;
      this.showChildText = item.batchName;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.eventPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.eventPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    onReset() {
      this.form.sxmc = "";
      this.form.timeStart = "";
      this.form.timeEnd = "";
      this.date = [];
      // this.page.page = 1;
      // this.page.size = 10;
      this.eventPageFun();
    },
    async selListFun(sxlx, deptName) {
      const res = await selMyDoList({ 
        // sxlx, 
        // deptName,
        page: 1,
        size: 1000,
        superFlag: "EVENT_TYPE_TYPE_FRC"
       });
      this.typeList = res.data.data || [];
      this.typeListALL = res.data.data || [];
      let deptNameALL = res.data.data && res.data.data.length ? res.data.data.filter(item=> !!item.tjDeptName).map(item => item.tjDeptName) : [];
      this.deptNameALL = [...new Set(deptNameALL)];
      this.ghEventTypeId = this.typeList.length ? this.typeList[0].id : "";
      if (this.typeList.length > 0) {
        this.typeChange(this.typeList[0]);
      }
    },
    // 导出批次
    async exportData(item) {
      this.exportLoading = true;
      let params = {
        extendBatchName: item.batchName,
        extendSearchKeyword: this.form.sxmc,
        communityName: "",
        extendFillBussinessInfoFlag: true,
        page: this.page.page,
        size: 99999,
        taskStatus: ""
      };
      let res = await extendTaskPageExp(params);
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "事项导出批次" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
    },
    // 分页查询
    async eventPageFun() {
      if (this.typeList.length === 0) {
        return;
      }
      let params = {
        extendSearchKeyword: this.form.sxmc,
        eventSuperFlagStr: "EVENT_TYPE_TYPE_FRC",
        ghEventTypeId: this.ghEventTypeId,
        // page: this.page.page,
        // size: this.page.size,
        // typeSource: "事项管理",
        timeStart: this.date && this.date.length ? this.date[0] : "",
        timeEnd: this.date && this.date.length ? this.date[1] : ""
      };
      const res = await batchGroupSomeList(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data
          ? res.data.data
          : [];
        this.page.total = res.data.data.length;
      }
    },
  },
  watch: {
    sxlx: {
      deep: true,
      handler(sxlx) {
        // this.selListFun(sxlx);
        if (sxlx) this.typeList = this.typeListALL.filter(item => item.sxlx.indexOf(sxlx) != -1);
        else this.typeList = this.typeListALL;
      }
    },
    deptName: {
      deep: true,
      handler(deptName) {
        // this.selListFun(deptName);
        if (deptName) this.typeList = this.typeListALL.filter(item => item.tjDeptName == deptName);
        else this.typeList = this.typeListALL;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  padding-bottom: 24px;

  .section {
    display: flex;
    padding: 0;

    .left {
      width: 25%;
      height: 100%;
      overflow: auto;
      padding: 28px 24px;
      border-right: 1px solid #e0e0e0;
    }

    .right {
      width: 75%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100% - 94px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin: 0 8px 6px 0;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .edit {
        width: 140px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/noPatrolReport/index.vue